<section class="help">
  <h1>{{ 'help.title' | translate }}</h1>

  <div class="white-box">
    <p>
      {{ 'help.support.check' | translate }} <a (click)="openFAQ()">{{ 'help.support.faq' | translate }}</a
      >.
    </p>
    <div class="line-divider"></div>
    <p>
      <b>{{ 'help.support.headline' | translate }}</b>
    </p>
    <p>{{ 'contact.reach' | translate }}</p>
    <ul>
      <li class="contact-item">
        <app-ds-rounded-icon icon="phone" variant="warning" color="var(--color-core-neutral-10)" /><span
          [innerHtml]="'contact.phoneNumber' | translate"
        ></span>
      </li>
      <li class="contact-item">
        <app-ds-rounded-icon icon="mail" variant="warning" color="var(--color-core-neutral-10)" /><span
          [innerHtml]="'contact.send_message' | translate"
        ></span>
      </li>
    </ul>
  </div>
</section>
